import { Component, Host, h, Prop } from '@stencil/core';
import { toValUnit } from './../../../utils/utils';

@Component({
  tag: 'afs-section',
  styleUrl: 'afs-section.sass',
  shadow: true,
})
export class AfsSection {

  @Prop() pXMobile : string = '1rem';
  @Prop() pYMobile : string = '0.8rem';
  @Prop() py0 : boolean = false;
  @Prop() pyThick : boolean = false;
  @Prop() pyBottomThick : boolean = false;
  @Prop() pyTopThick : boolean = false;
  @Prop() setHeading : boolean = false;
  @Prop() backgroundColor : string = "transparent";
  @Prop() color : string = "#000000";
  @Prop() linkColor : string = "inherit";
  @Prop() setDecoratorTop : boolean = false;
  @Prop() setDecoratorBottom : boolean = false;
  @Prop() decoratorTopAbsolute : boolean = false;
  @Prop() decoratorBottomAbsolute : boolean = false;
  @Prop() maxWidth : string = "1024px";

  render() {
    return (
      <Host style={{ 
        padding: `${ toValUnit(this.pYMobile) } ${ toValUnit(this.pXMobile) }`,
        paddingTop: this.py0 ? '0' : this.pyThick ? '2rem' : this.pyTopThick && '2rem',
        paddingBottom: this.py0 ? '0' : this.pyThick ? '2rem' : this.pyBottomThick && '2rem',
        backgroundColor: this.backgroundColor, 
        color: this.color,
        '--afs-link-color': this.linkColor
      }}>
        { this.setDecoratorTop && <div class={`decorator decorator-top ${ this.decoratorTopAbsolute && 'decorator-top-absolute' }`}></div> }
        <section class="container-wrapper" style={{maxWidth: this.maxWidth}}>
          {this.setHeading &&  <div class="heading"><slot name="heading"></slot></div>}
          <div class="content">
            <slot></slot>
          </div>
        </section>
        { this.setDecoratorBottom && <div class={`decorator decorator-bottom ${ this.decoratorBottomAbsolute && 'decorator-bottom-absolute' }`}></div> }
      </Host>
    );
  }

}
